import { useState } from 'react';
import { getDebugInfo } from '../../utils/debug';

interface ProductionDebugProps {
  show?: boolean;
}

export function ProductionDebug({ show = false }: ProductionDebugProps) {
  const [isVisible, setIsVisible] = useState(show);
  const debugInfo = getDebugInfo();

  if (!isVisible) {
    return (
      <button
        onClick={() => setIsVisible(true)}
        style={{
          position: 'fixed',
          bottom: '10px',
          right: '10px',
          zIndex: 9999,
          padding: '8px 12px',
          backgroundColor: '#ff6b6b',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          fontSize: '12px',
          cursor: 'pointer'
        }}
      >
        Debug
      </button>
    );
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: '10px',
        right: '10px',
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        color: 'white',
        padding: '16px',
        borderRadius: '8px',
        fontSize: '12px',
        maxWidth: '400px',
        maxHeight: '80vh',
        overflow: 'auto',
        fontFamily: 'monospace'
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
        <h3 style={{ margin: 0 }}>🔍 Production Debug</h3>
        <button
          onClick={() => setIsVisible(false)}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            fontSize: '16px',
            cursor: 'pointer'
          }}
        >
          ×
        </button>
      </div>

      <div style={{ marginBottom: '8px' }}>
        <strong>Environment:</strong> {debugInfo.environment}
      </div>
      
      <div style={{ marginBottom: '8px' }}>
        <strong>Version:</strong> {debugInfo.buildInfo.version}
      </div>
      
      <div style={{ marginBottom: '8px' }}>
        <strong>Commit:</strong> {debugInfo.buildInfo.commit.substring(0, 7)}
      </div>
      
      <div style={{ marginBottom: '8px' }}>
        <strong>API URL:</strong> {debugInfo.apiUrl}
      </div>
      
      <div style={{ marginBottom: '8px' }}>
        <strong>Weather Config:</strong> {debugInfo.hasWeatherConfig ? '✅' : '❌'}
      </div>
      
      <div style={{ marginBottom: '8px' }}>
        <strong>Location Config:</strong> {debugInfo.hasLocationConfig ? '✅' : '❌'}
      </div>
      
      <div style={{ marginBottom: '8px' }}>
        <strong>Build Time:</strong> {new Date(debugInfo.buildInfo.buildTime).toLocaleString()}
      </div>

      <div style={{ marginTop: '12px', paddingTop: '8px', borderTop: '1px solid #333' }}>
        <button
          onClick={() => {
            console.log('Debug info:', debugInfo);
            alert('Debug info logged to console');
          }}
          style={{
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            padding: '6px 12px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '11px'
          }}
        >
          Log to Console
        </button>
      </div>
    </div>
  );
}
